export default __webpack_public_path__ + "static/media/singer.ba2d8ec8.jpg";